import React from 'react';
import PropTypes from 'prop-types';
import BodyClassName from 'react-body-classname';
export var NavWrapper = function NavWrapper(_ref) {
  var children = _ref.children,
      isMobile = _ref.isMobile;
  return isMobile ? React.createElement(BodyClassName, {
    className: "body--hide-content"
  }, React.createElement("div", {
    className: "header__mobile-panel"
  }, children)) : React.createElement("div", {
    className: "header__nav"
  }, children);
};
NavWrapper.propTypes = {
  isMobile: PropTypes.bool,
  children: PropTypes.node.isRequired
};